export var ERewardAssetType;
(function (ERewardAssetType) {
    ERewardAssetType["ASSET"] = "Asset";
    ERewardAssetType["POLICY"] = "Policy";
})(ERewardAssetType || (ERewardAssetType = {}));
//# sourceMappingURL=appConfig.js.map